import { type SxProps, type Theme } from '@mui/system';

export const cardSx: SxProps<Theme> = {
  position: 'relative',
  background: '#FFFFFF',
  margin: '0px 0px 34px 0px',
  maxHeight: {
    md: 'none',
  },
  height: {
    xs: 'auto',
  },
  width: '100%',
  boxShadow: '0px 3px 6px #00000029',
  padding: {
    xs: '20px 20px 20px 26px',
    lg: '20px 120px 20px 26px',
  },
  boxSizing: 'border-box',
  borderLeft: '2px solid #006ec2',
  display: 'flex',
  flexDirection: {
    xs: 'column',
    md: 'row',
  },
  '&:hover': {
    cursor: 'pointer',
  },
  '& .wrapper': {
    flex: 1,
    wordBreak: 'break-word',
  },
  '& .title': {
    color: '#006ec2',
    fontSize: '24px',
    lineHeight: '34px',
    fontWeight: 'bold',
    marginBottom: '2px',
  },
  '& .header': {
    minHeight: '35px',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: '5px',
    '& .header-left': {
      display: 'flex',
      flexDirection: {
        xs: 'column',
        md: 'row',
      },
      columnGap: '16.5px',
      rowGap: '3px',
      alignItems: {
        xs: 'start',
        md: 'center',
      },
      '& .score': {
        fontSize: '14px',
        background: '#006EC2',
        padding: '2px 4px',
        lineHeight: '17px',
        borderRadius: '2px',
        color: '#FFFFFF',
        fontWeight: 400,
        height: '20px',
      },
    },
    '& .header-right': {
      display: {
        xs: 'none',
        md: 'block',
      },
    },
  },
  '& .footer': {
    display: {
      xs: 'block',
      md: 'none',
    },
    marginTop: '10px',
  },
  '& .action': {
    width: '135px',
    minHeight: '35px',
    fontSize: '18px',
    borderRadius: '2px',
    color: '#FFFFFF',
    '&.expired': {
      backgroundColor: '#707070',
      textAlign: 'center',
      lineHeight: '35px',
    },
    '&.live': {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      gap: '12px',
      backgroundColor: '#006EC2',
    },
    '&.completed': {
      backgroundColor: '#009869',
      textAlign: 'center',
      lineHeight: '35px',
    },
  },
  '& .info': {
    fontSize: '18px',
    color: '#006EC2',
    display: 'flex',
    alignItems: 'center',
  },

  '& .content': {
    fontSize: '18px',
    lineHeight: '22px',
    color: '#000000',
    marginTop: '8px',
  },
  '& .detail': {
    marginTop: '30px',
    display: 'flex',
    flexDirection: {
      xs: 'column',
      md: 'row',
    },
    gap: '40px',
    '& .detail-thumbnail': {
      flexShrink: 0,
      width: {
        xs: '100%',
        md: '50%',
        lg: '535px',
      },
    },
    '& .detail-steps': {
      flexShrink: 1,
      '& .step-progress': {
        marginTop: '20px',
      },
      '& .step-description': {
        marginTop: '30px',
      },
    },
  },
};
